/**
 * FairwayBid – Inhalte der Händlerseite
 *
 * Händler sind die zahlende Seite des Marktplatzes. Golfanlagen kommen
 * wegen des Bedarfs, Händler kommen wegen der Rechnung, die daraus wird –
 * diese Seite muss also nicht erklären, sondern überzeugen.
 *
 * Aufbau der Argumentation: erst der Beleg, dass es hier Nachfrage gibt
 * (Zahlenband), dann was ein Händler davon hat, dann wie wenig Aufwand es
 * ist, und zum Schluss, was es kostet. Der Preis steht bewusst am Ende:
 * Wer bis dahin gelesen hat, fragt nach dem Preis, nicht nach dem Grund.
 *
 * Texte hier ändern, nicht im Code des Bausteins.
 */

/** Abschnitte, die diesen Baustein bekommen. */
export const DEALER_PAGE_ID = 'fuer-haendler';
export const DEALER_TYPE = 'fwb-haendler';

export const DEALER_FEATURES = [
  {
    key: 'kalt',
    headline: 'Keine Kaltakquise',
    text:
      'Der Bedarf liegt schon auf dem Tisch. Sie rufen niemanden mehr an, der gerade nichts braucht – Sie antworten jemandem, der gerade kauft.',
  },
  {
    key: 'streu',
    headline: 'Kein Streuverlust',
    text:
      'Sie hinterlegen einmal Ihre Kategorien und Lieferländer. Danach sehen Sie nur die Ausschreibungen, die zu Ihrem Sortiment gehören.',
  },
  {
    key: 'vergleich',
    headline: 'Ihre Leistung statt Ihres Prospekts',
    text:
      'Alle Angebote haben dieselbe Struktur: Preis, Lieferzeit, Garantie, Montage. Der Club vergleicht Sachliches – da zählt, was Sie können, nicht wer den dicksten Katalog schickt.',
  },
  {
    key: 'vorsprung',
    headline: 'Zeitvorsprung',
    text:
      'Mit Professional und Premium sehen Sie neue Anfragen vor allen anderen. Wer zuerst antwortet, ist im Gespräch, bevor der Vergleich beginnt.',
  },
];

export const DEALER_STEPS = [
  {
    title: 'Konto anlegen',
    text:
      'Firma, Kategorien und Lieferländer angeben. Wir prüfen die Angaben einmalig und schalten Sie frei. Dauert zwei Minuten.',
  },
  {
    title: 'Passende Anfragen erhalten',
    text:
      'Sie sehen die Ausschreibungen, die zu Ihrem Sortiment gehören – mit Budgetrahmen, Menge und Frist.',
  },
  {
    title: 'Angebot abgeben',
    text:
      'Preis, Lieferzeit, Garantie und Montage eintragen, absenden. Lieferung und Rechnung laufen danach direkt zwischen Ihnen und der Golfanlage.',
  },
];

/** Was in welchem Tarif drin ist – die Zahlen kommen aus membership.js. */
export const PLAN_NOTES = {
  basis: 'Zum Ausprobieren. Sie sehen alle Anfragen, nur später als die anderen.',
  professional: 'Für Händler, die regelmäßig anbieten. Zwölf Stunden Vorsprung.',
  premium: 'Für Hersteller und Großhändler. Kein Limit, kein Warten.',
};

export const PRICE_NOTE =
  'Preise netto pro Monat, monatlich kündbar. Für Golfanlagen ist FairwayBid kostenlos – Sie zahlen nur für den Zugang zu den Anfragen, nicht für den Abschluss. Es gibt keine Provision auf Ihre Umsätze.';
